module.exports = __webpack_public_path__ + "img/Above_and_Beyond.d3618cb9.svg";